export const DECIMAL_TIME_REGEX = /^\d+(?:[.,]\d+)?$/;

export const WORDED_TIME_REGEX = /\d+/gi;

// in compliance with:
// decimal numbers using both separators (,.)
// time string formats (5:30, 5h30m, 5h 30m, 5h 30min, 5h30min)
export const WORDED_TIME_VALIDATION_REGEX = /^(\d{1,2})(h\s*(\d{1,2})(m|min)?|[:.,](\d{1,2}))$/;

export const HOURS_MIN = 0;

export const HOURS_MAX = 24;

export const MINUTES_MAX = 60;

export const TIME_MAX = "23:59";

export const TIME_MIN = "00:00";

export const MAX_HOURS_TIME_INPUT_12H = 12;

export const MAX_HOURS_TIME_INPUT_24H = 23;
